import { useSelector } from 'react-redux';

import { getCatalogFieldFacetsUrl } from 'api/CatalogAPI';
import { useRestQuery } from 'utils/hooks/api';
import { isEmptyString } from 'utils/stringHelpers';
import { isDefined } from 'utils/tsHelpers';

import { useConditionState } from '../useConditionState';
import { getCatalogName } from '../../helpers';
import { FieldFacet } from '../../types';

export const useCatalogFieldFacets = (enabled = true) => {
  const catalogName = useSelector(getCatalogName);
  const [{ field }] = useConditionState();
  const {
    data: { catalogFieldValues = [] } = {},
    isLoading,
    error,
  } = useRestQuery<{
    catalogFieldValues: string[];
  }>(
    getCatalogFieldFacetsUrl(catalogName, field),
    {},
    { enabled: enabled && !isEmptyString(field) && isDefined(catalogName) },
  );
  const facets = catalogFieldValues.map((term): FieldFacet => ({ term, count: 0 }));
  return { facets, isLoading, error };
};
